// Arabic translations
export const translationsAR = {
  nav: {
    home: "الرئيسية",
    icfPlans: "خطط ICF متعددة الوحدات",
    shop: "المتجر",
    sixPlex: "6-بلكس ICF",
    eightPlex: "8-بلكس ICF",
    twelvePlex: "12-بلكس ICF",
    townhomes: "تاون هومز ICF",
    investors: "المستثمرون والمقرضون",
    process: "من الخطة إلى التصريح",
    about: "من نحن",
    team: "فريقنا",
    contact: "اتصل بنا",
    blog: "المدونة"
  },
  hero: {
    headline: "تصاميم مباني متعددة الوحدات محسنة لتحقيق أقصى ربحية للمطورين العقاريين",
    subheadline: "دخل إيجاري أقصى. تكاليف بناء محسنة. عوائد مضمونة.",
    viewPlans: "عرض الخطط",
    downloadGuide: "تحميل دليل المستثمرين"
  },
  whyUs: {
    title: "لماذا تختار Plexterra؟",
    point1Title: "متخصصون في ICF متعدد الوحدات",
    point1Text: "خبرة معترف بها في تصميم المجمعات السكنية بقوالب العزل الخرسانية.",
    point2Title: "خطط جاهزة للتكيف",
    point2Text: "مفاهيم معمارية محسنة، قابلة للتكيف مع أرضك وولايتك القضائية.",
    point3Title: "التوافق مع SCHL",
    point3Text: "خطط تلبي معايير الأداء العالي للطاقة.",
    point4Title: "رؤية دولية",
    point4Text: "مصممة للأسواق الكندية والأمريكية والدولية."
  },
  icf: {
    title: "تقنية ICF: مبنية لتدوم",
    benefit1Title: "متانة 100+ عام",
    benefit1Text: "هيكل خرساني مسلح مقاوم للعوامل الجوية والحريق.",
    benefit2Title: "كفاءة الطاقة",
    benefit2Text: "عزل R-22 إلى R-50، توفير يصل إلى 50% في الطاقة.",
    benefit3Title: "تقليل المخاطر",
    benefit3Text: "حوادث أقل، أقساط تأمين مخفضة تصل إلى 25%.",
    benefit4Title: "قيمة ESG",
    benefit4Text: "بصمة كربونية مخفضة، امتثال لمعايير الاستدامة.",
    learnMore: "اعرف المزيد عن ICF"
  },
  plans: {
    title: "الخطط المتعددة الوحدات المتاحة",
    subtitle: "مفاهيم محسنة لتحقيق أقصى عائد لكل قدم مربع",
    viewPlan: "عرض الخطة",
    idealFor: "مثالي لـ",
    urbanLots: "الأراضي الحضرية",
    midSize: "المشاريع المتوسطة",
    largeScale: "المشاريع الكبيرة",
    rowHouses: "المنازل المتلاصقة"
  },
  esg: {
    title: "الاستدامة والتمويل: ميزة ESG",
    text: "تم تصميم خططنا ICF لتلبية متطلبات الاستدامة المتزايدة. التوافق مع SCHL وخصائص ESG تسهل:",
    point1: "الوصول إلى التمويل المصرفي",
    point2: "أسعار تفضيلية للمشاريع الخضراء",
    point3: "الأهلية للدعم الحكومي",
    point4: "تقدير طويل الأمد للأصول",
    viewSheet: "عرض ورقة المستثمر"
  },
  cta: {
    title: "هل أنت مستعد للاستثمار في عقارات الغد؟",
    card1Title: "عرض الخطط",
    card1Text: "استكشف مفاهيمنا 6-بلكس، 8-بلكس و12-بلكس.",
    card1Button: "المتجر",
    card2Title: "دليل المستثمرين",
    card2Text: "قم بتنزيل وثائقنا الكاملة.",
    card2Button: "تحميل (PDF)",
    card3Title: "اتصل بنا",
    card3Text: "دعنا نناقش مشروعك الاستثماري.",
    card3Button: "اتصال"
  },
  icfPage: {
    h1: "خطط ICF متعددة الوحدات للمستثمرين",
    subtitle: "مفاهيم معمارية بمستوى مؤسسي، محسنة للأداء المالي والاستدامة.",
    whatIsIcf: "ما هو ICF؟",
    icfExplanation: "قوالب الخرسانة المعزولة (ICF) هي نظام بناء حيث تعمل كتل البوليسترين الموسع كقوالب دائمة للخرسانة المسلحة. توفر هذه التقنية عزلاً حرارياً استثنائياً ومتانة لا مثيل لها.",
    whyInvestorsTitle: "لماذا يختار المستثمرون ICF",
    reducedCosts: "تكاليف تشغيل مخفضة",
    reducedCostsPoints: ["توفير 40-50% في التدفئة/التبريد", "صيانة هيكلية أقل", "عمر افتراضي 100+ عام"],
    riskReduction: "تقليل المخاطر",
    riskReductionPoints: ["مقاومة للحريق 4 ساعات (مقابل ساعة واحدة للخشب)", "مقاومة للظروف الجوية القاسية", "أقساط تأمين مخفضة تصل إلى 25%"],
    betterFinancing: "تمويل أفضل",
    betterFinancingPoints: ["امتثال ESG مطلوب من المقرضين", "الأهلية للبرامج الخضراء", "قيمة إعادة بيع أعلى"],
    rentalStability: "استقرار الإيجار",
    rentalStabilityPoints: ["راحة صوتية فائقة", "فواتير طاقة مخفضة", "صورة حديثة ومستدامة"],
    comparisonTitle: "ICF مقابل الهيكل الخشبي",
    criteria: "المعايير",
    woodFrame: "الهيكل الخشبي",
    lifespan: "العمر الافتراضي",
    years: "سنة",
    insulation: "العزل (قيمة R)",
    fireResistance: "مقاومة الحريق",
    hours: "ساعات",
    hour: "ساعة",
    energyCosts: "تكاليف الطاقة",
    baseline: "المرجع",
    maintenance: "الصيانة الهيكلية",
    minimal: "الحد الأدنى",
    moderate: "متوسط",
    insurancePremium: "قسط التأمين",
    soundproofing: "عزل الصوت",
    excellent: "ممتاز",
    poor: "ضعيف",
    resaleValue: "قيمة إعادة البيع",
    higher: "أعلى",
    standard: "قياسي",
    availableFormats: "الصيغ المتاحة",
    importantNotice: "ملاحظة مهمة",
    noticeText: "خططنا هي مفاهيم معمارية تتطلب التكيف من قبل مهندس معماري محلي لـ: الامتثال لقانون البناء في ولايتك القضائية، والتكيف مع خصائص أرضك، والتصديق من قبل مهندس مرخص. Plexterra ليست مقاولاً عاماً. نحن نصمم خططاً تقدمها للمحترفين الذين تختارهم."
  },
  investors: {
    h1: "للمستثمرين والمقرضين",
    subtitle: "وثائق بمستوى مصرفي لاتخاذ قرارات واثقة.",
    whyBankable: "لماذا هذه المشاريع قابلة للتمويل",
    icfAdvantages: "مزايا ICF الهيكلية",
    icfPoints: ["متانة 100+ عام تقلل المخاطر طويلة الأمد", "مقاومة الحريق والطقس تقلل المطالبات", "أقساط تأمين أقل تحسن NOI"],
    financialPerformance: "الأداء المالي",
    financialPoints: ["توفير 40-50% في الطاقة يزيد NOI", "تكاليف صيانة أقل على مدار دورة حياة المبنى", "احتفاظ أعلى بالمستأجرين بسبب الراحة"],
    esgTitle: "ESG والاستدامة",
    esgPoints: ["بصمة كربونية مخفضة متوافقة مع تفويضات ESG", "امتثال SCHL يلبي معايير التمويل الأخضر", "حماية مستقبلية ضد تشديد لوائح الطاقة"],
    rentalTitle: "استقرار الإيجار",
    rentalPoints: ["عزل صوتي فائق = مستأجرون أسعد", "تكاليف مرافق أقل = إيجارات تنافسية", "بناء حديث = تموضع متميز"],
    keyMetrics: "المقاييس الرئيسية",
    downloadPack: "تحميل حزمة المستثمر"
  },
  process: {
    h1: "من الخطة إلى التصريح",
    subtitle: "عملية مبسطة لتحقيق مشروعك الاستثماري.",
    step1Title: "اختيار الخطة",
    step1Text: "اختر من مفاهيمنا ICF 6-بلكس، 8-بلكس، 12-بلكس أو تاون هومز بناءً على أهدافك الاستثمارية.",
    step2Title: "شراء المفهوم",
    step2Text: "اشترِ الحزمة الكاملة بما في ذلك الخطط المعمارية والوثائق التقنية ودليل التكيف.",
    step3Title: "التكيف المحلي",
    step3Text: "يقوم مهندسك المعماري بتكييف المفهوم مع أرضك ومتطلبات قانون البناء المحلي.",
    step4Title: "التصديق",
    step4Text: "يصادق مهندس مرخص على الخطط الهيكلية المتكيفة مع ولايتك القضائية.",
    step5Title: "تصريح البناء",
    step5Text: "قدم الخطط المصدقة إلى بلديتك للحصول على تصريح البناء.",
    step6Title: "البناء",
    step6Text: "اختر مقاولاً مؤهلاً في ICF وابدأ بناء مشروعك.",
    whatIncluded: "ما يشمله الشراء",
    includedItems: [
      "خطط معمارية مفصلة (PDF + CAD)",
      "المواصفات التقنية ICF",
      "دليل التكيف للمهندس المعماري",
      "ورقة بيانات المستثمر",
      "تقديرات التكلفة الإرشادية",
      "دعم البريد الإلكتروني (30 يوماً)"
    ],
    startProject: "ابدأ مشروعك"
  },
  about: {
    h1: "عن Plexterra",
    subtitle: "شريكك الموثوق في تصميم ICF متعدد الوحدات.",
    missionTitle: "مهمتنا",
    missionText: "Plexterra مكرسة لتصميم خطط ICF متعددة الوحدات بمستوى مؤسسي. مهمتنا هي تزويد المستثمرين العقاريين بمفاهيم معمارية محسنة للأداء المالي والاستدامة البيئية.",
    expertiseTitle: "خبرتنا",
    expertiseText: "متخصصون في قوالب الخرسانة المعزولة (ICF)، نجمع بين الابتكار في البناء والدقة المالية لإنشاء خطط تلبي متطلبات أكثر المستثمرين والمقرضين تطلباً.",
    valuesTitle: "قيمنا",
    value1Title: "التميز",
    value1Text: "خطط بمستوى مؤسسي، قابلة للتقديم لأي لجنة ائتمان مصرفية.",
    value2Title: "الابتكار",
    value2Text: "تقنية ICF المتطورة لأقصى متانة وكفاءة.",
    value3Title: "الشفافية",
    value3Text: "وثائق كاملة وواقعية، بدون وعود مبالغ فيها.",
    value4Title: "الاستدامة",
    value4Text: "الالتزام بمعايير ESG والبناء المسؤول.",
    marketsTitle: "أسواقنا",
    marketsText: "تم تصميم خططنا لتكون قابلة للتكيف مع الأسواق الكندية والأمريكية والدولية، مع اهتمام خاص بقوانين البناء ومتطلبات التمويل لكل ولاية قضائية."
  },
  contact: {
    h1: "اتصل بنا",
    subtitle: "دعنا نناقش مشروعك الاستثماري متعدد الوحدات.",
    formTitle: "أرسل لنا رسالة",
    name: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "الهاتف (اختياري)",
    company: "الشركة (اختياري)",
    projectType: "نوع المشروع",
    selectProject: "اختر نوع المشروع",
    project6plex: "6-بلكس ICF",
    project8plex: "8-بلكس ICF",
    project12plex: "12-بلكس ICF",
    projectTownhomes: "تاون هومز ICF",
    projectOther: "آخر",
    message: "الرسالة",
    messagePlaceholder: "صف مشروعك الاستثماري...",
    submit: "إرسال الرسالة",
    sending: "جارٍ الإرسال...",
    successTitle: "تم إرسال الرسالة!",
    successText: "سنرد عليك خلال 24-48 ساعة.",
    infoTitle: "معلومات",
    responseTime: "وقت الاستجابة: 24-48 ساعة",
    languages: "اللغات: Français, English, Español, العربية, 中文",
    markets: "الأسواق: كندا، الولايات المتحدة، دولي"
  },
  product: {
    from: "يبدأ من",
    addToCart: "اطلب هذه الخطة",
    features: "الميزات",
    specifications: "المواصفات التقنية",
    units: "الوحدات",
    floors: "الطوابق",
    sqft: "المساحة",
    fireRating: "تصنيف الحريق",
    rValue: "قيمة R",
    included: "ما يشمله",
    includedItems: [
      "خطط معمارية مفصلة (PDF + CAD)",
      "المواصفات التقنية ICF",
      "دليل التكيف للمهندس المعماري",
      "ورقة بيانات المستثمر",
      "دعم البريد الإلكتروني (30 يوماً)"
    ],
    disclaimer: "ملاحظة: هذه الخطط هي مفاهيم معمارية تتطلب التكيف من قبل مهندس معماري محلي مرخص."
  },
  footer: {
    tagline: "Multiplex Designs for Developers",
    quickLinks: "روابط سريعة",
    legal: "قانوني",
    legalNotice: "إشعار قانوني",
    privacyPolicy: "سياسة الخصوصية",
    termsOfSale: "شروط البيع",
    newsletter: "النشرة الإخبارية",
    newsletterText: "احصل على آخر أخبارنا وعروضنا.",
    subscribe: "اشترك",
    subscribing: "جارٍ الاشتراك...",
    subscribed: "تم الاشتراك!",
    emailPlaceholder: "بريدك الإلكتروني",
    rights: "جميع الحقوق محفوظة."
  },
  blog: {
    title: "المدونة",
    subtitle: "مقالات وأدلة حول الاستثمار العقاري ICF",
    readMore: "اقرأ المزيد",
    backToBlog: "العودة إلى المدونة",
    publishedOn: "نُشر في",
    category: "الفئة",
    relatedArticles: "مقالات ذات صلة"
  }
};
